import api from './index'

export function getProductDeliveryExchangeTemplates(params) {
  return api.get('/api/v1/product-delivery-exchange-templates', { params })
}

export function getProductDeliveryExchangeTemplate(templateCode) {
  return api.get(`/api/v1/product-delivery-exchange-templates/${templateCode}`)
}

export function createProductDeliveryExchangeTemplate(data) {
  return api.post('/api/v1/product-delivery-exchange-templates', data)
}

export function updateProductDeliveryExchangeTemplate(templateCode, data) {
  return api.put(`/api/v1/product-delivery-exchange-templates/${templateCode}`, data)
}

export function deleteProductDeliveryExchangeTemplate(templateCode) {
  return api.delete(`/api/v1/product-delivery-exchange-templates/${templateCode}`)
}

export function uploadProductDeliveryExchangeTemplateImage(templateCode, imageType, file) {
  const formData = new FormData()
  formData.append('imageType', imageType)
  formData.append('file', file)
  return api.post(`/api/v1/product-delivery-exchange-templates/${templateCode}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function deleteProductDeliveryExchangeTemplateImage(templateCode, imageCode) {
  return api.delete(`/api/v1/product-delivery-exchange-templates/${templateCode}/images/${imageCode}`)
}
